export const eProductFields = [
  {
    key: 'value',
    label: 'Value',
  },
  {
    key: 'image',
    label: 'Image',
  },
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'description',
    label: 'Description',
  },
  {
    key: 'remarks',
    label: 'Short Remarks',
  },
  {
    key: 'quantity',
    label: 'Quantity',
  },
  {
    key: 'price',
    label: 'Price',
  },
  {
    key: 'discountPrice',
    label: 'Discount Price',
  },
  {
    key: 'isSold',
    label: 'Is Sold Out',
  },
  {
    key: 'isOnSale',
    label: 'On Sale',
  },
  {
    key: 'customTag',
    label: 'Custom Tag',
  },
  {
    key: 'customTagColor',
    label: 'Custom Tag Color',
  },
  {
    key: 'isShippable',
    label: 'Is Shippable',
  },
  {
    key: 'isShowStock',
    label: 'Is Show Stock',
  },
  {
    key: 'parent',
    label: 'Parent Product',
  },
]
